export const COMMISSION_RETENTION_RATE = 0.1525;

const toNonNegativeNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, number) : 0;
};

export const calculateCommissionAmount = (production, percent) =>
  Math.round(toNonNegativeNumber(production) * (Math.min(100, toNonNegativeNumber(percent)) / 100));

export const calculateCommissionSummary = ({
  serviceTotal,
  commissionPercent,
  advances,
  withdrawals,
}) => {
  const grossCommission = calculateCommissionAmount(serviceTotal, commissionPercent);
  const retention = Math.round(grossCommission * COMMISSION_RETENTION_RATE);
  const netCommission = grossCommission - retention;
  const totalDeductions = toNonNegativeNumber(advances) + toNonNegativeNumber(withdrawals);

  return {
    grossCommission,
    retention,
    netCommission,
    totalDeductions,
    finalTotal: netCommission - totalDeductions,
  };
};

export const formatCurrencyCL = (value) =>
  `$${new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(Math.round(Number(value) || 0))}`;
